import type { EffectSelectDto } from '@@types/api.types';

export const normalizeEffectDefinitionKey = (name: string): string => name.trim().toLowerCase();

export const buildEffectDefinitionByName = (effects: EffectSelectDto[]): Map<string, string> => {
  const definitions = new Map<string, string>();

  for (const effect of effects) {
    if (effect.description) {
      definitions.set(normalizeEffectDefinitionKey(effect.name), effect.description);
    }

    for (const secondaryEffect of effect.secondaryEffects ?? []) {
      if (secondaryEffect.description) {
        definitions.set(normalizeEffectDefinitionKey(secondaryEffect.name), secondaryEffect.description);
      }
    }
  }

  return definitions;
};
